import { defaultFilter } from 'components/molecules/filters/utils';
import { ViewDefinitionTransformer } from 'components/molecules/views';
import { FilterableField } from 'components/organisms/tasks/fields';
import { FieldFilter } from 'components/organisms/tasks/filters';
import {
  from_filter,
  to_filter,
} from 'components/pages/api-filter-transformer';
import {
  ApiTimesheetReportViewDefinition,
  TimesheetReportViewDefinition,
} from './types';

export const getViewDefinitionTransformer = (
  lookup: Record<string, FilterableField>,
): ViewDefinitionTransformer<
  ApiTimesheetReportViewDefinition,
  TimesheetReportViewDefinition
> => ({
  from: ({
    filter: viewDefinitionFilter,
  }: ApiTimesheetReportViewDefinition): TimesheetReportViewDefinition => ({
    filter: viewDefinitionFilter
      ? from_filter(lookup)(viewDefinitionFilter)
      : defaultFilter,
  }),
  to: ({
    filter: viewDefinitionFilter,
  }: TimesheetReportViewDefinition): ApiTimesheetReportViewDefinition => {
    const isFilterValid =
      viewDefinitionFilter.criteria.filter(FieldFilter.isValid).length > 0;

    return {
      filter: isFilterValid ? to_filter(viewDefinitionFilter) : undefined,
    };
  },
});
